import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/crm/Oportunidad/Embudo',
  alias: [],
  documento: 'crm',
  filas: ['133'],
  acceso: 'sesion',
  cita: 'prod:Areas/CRM/Controllers/OportunidadController.cs:92',
} satisfies RutaProd;
